import React from 'react';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

const DropdownMenuWrap = ({ btnStyle, trigger = 'click', placement = 'bottomRight', ...other }) => {
  return (
    <Dropdown
      trigger={trigger}
      placement={placement}
      {...other}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
    >
      <Button type="link" onClick={(e) => e.stopPropagation()} style={btnStyle}>
        <MoreOutlined style={{ fontSize: 24 }} />
      </Button>
    </Dropdown>
  );
};

export default DropdownMenuWrap;
